import { render, staticRenderFns } from "./iframeViewer.vue?vue&type=template&id=7b8f2b98"
import script from "./iframeViewer.vue?vue&type=script&lang=js"
export * from "./iframeViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports